<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>单页面</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/single/index">单页面列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加单页面</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加单页面</span>
      </div>
      <div class="xcx-content">
        <div id="main" style="width: 600px; height: 400px"></div>
        <div id="line" style="width: 600px; height: 400px"></div>
        <div id="series" style="width: 1200px; height: 400px"></div>
        <div id="maps" style="width: 1200px; height: 800px"></div>
      </div>
    </div>
  </div>
</template>
<script>
import china from "echarts/map/json/china.json";
import henan from "echarts/map/json/province/henan.json";

export default {
  data() {
    return {
      loading: false,
      id: "",
      courseData: {
        columns: ["日期", "听课时长"],
        rows: [
          { 日期: "8月1日", 听课时长: 1103 },
          { 日期: "8月2日", 听课时长: 1223 },
          { 日期: "8月3日", 听课时长: 2323 },
          { 日期: "8月4日", 听课时长: 4423 },
          { 日期: "8月5日", 听课时长: 3523 },
          { 日期: "8月6日", 听课时长: 7623 },
          { 日期: "8月7日", 听课时长: 7723 },
          { 日期: "8月8日", 听课时长: 3823 },
          { 日期: "8月9日", 听课时长: 2923 },
          { 日期: "8月10日", 听课时长: 2123 },
          { 日期: "8月11日", 听课时长: 8023 },
          { 日期: "8月12日", 听课时长: 9023 },
        ],
      },
    };
  },

  /**
   * 进入页面加载
   */
  mounted() {
    console.log(henan);
    this.drawChart();
    this.drawChart1();
    this.drawChart2();
    this.drawChart3();
  },
  methods: {
    /**
     * 地图数据
     */
    randomData: function () {
      return Math.round(Math.random() * 1000);
    },

    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("main"));
      // 指定图表的配置项和数据
      let option = {
        title: {
          text: "ECharts 入门示例",
        },
        tooltip: {},
        legend: {
          data: ["销量"],
        },
        xAxis: {
          data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"],
        },
        yAxis: {},
        series: [
          {
            name: "销量",
            type: "bar",
            data: [5, 20, 36, 10, 10, 20],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart1() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("line"));
      // 指定图表的配置项和数据
      let option = {
        title: {
          text: "ECharts 入门示例222",
        },
        tooltip: {},
        legend: {
          data: ["销量"],
        },
        xAxis: {
          data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"],
        },
        yAxis: {},
        series: [
          {
            name: "销量",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            smooth: true,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart2() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("series"));
      // 指定图表的配置项和数据
      let option = {
        color: ["#80FFA5", "#00DDFF"],
        title: {
          text: "Gradient Stacked Area Chart",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["Line 1", "Line 2"],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Line 1",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(255, 255, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [140, 232, 101, 264, 90, 340, 250],
          },
          {
            name: "Line 2",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [120, 282, 111, 234, 220, 340, 310],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart3() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("maps"));
      this.$echarts.registerMap("china", china);
      // 指定图表的配置项和数据
      let option = {
        title: {
          text: "ECharts 入门示例222",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal", //图例的排列方向
          textStyle: { color: "#ccc" },
          x: "left", //图例的位置
          y: "-20000000000000",

          // data: ["全国数据"]
        },

        visualMap: {
          //颜色的设置  dataRange
          textStyle: { color: "#ccc" },
          x: "left",
          y: "bottom",
          splitList: [
            // { start: 1500 },
            // { start: 900, end: 1500 },
            // { start: 310, end: 1000 },
            // { start: 200, end: 300 },
            // { start: 50, end: 200 },
            { start: 0, end: 150000 },
          ],
          show: false,
          // text:['高','低'],// 文本，默认为数值文本
          color: ["#E6EFFF"],
          // color: [
          //     "#5475f5",
          //     "#9feaa5",
          //     "#3FA7FF",
          //     "#66E0E3",
          //     "#FFDC5E",
          //     "#9fb5ea"
          // ]
        },
        roamController: {
          //控制地图的上下左右放大缩小
          show: true,
          x: "right",
          mapTypeControl: {
            china: true,
          },
        },
        series: [
          {
            name: "全国数据",
            type: "map",
            mapType: "china",
            zoom: 1.1, //地图大小
            roam: false, //是否开启鼠标缩放和平移漫游
            itemStyle: {
              //地图区域的多边形 图形样式
              normal: {
                //是图形在默认状态下的样式
                label: {
                  show: true,
                  textStyle: { color: "#000000" }, //地图text样式
                },
              },
              emphasis: {
                //是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                areaColor: "#6A9FFF",
                label: { show: true },
              },
            },
            top: "100", //组件距离容器的距离
            data: [
              { name: "上海", value: this.randomData() },
              { name: "北京", value: "100" },
              { name: "天津", value: this.randomData() },
              { name: "重庆", value: this.randomData() },
              { name: "河北", value: this.randomData() },
              { name: "河南", value: this.randomData() },
              { name: "云南", value: this.randomData() },
              { name: "辽宁", value: this.randomData() },
              { name: "黑龙江", value: this.randomData() },
              { name: "湖南", value: this.randomData() },
              { name: "安徽", value: this.randomData() },
              { name: "山东", value: this.randomData() },
              { name: "新疆", value: this.randomData() },
              { name: "江苏", value: this.randomData() },
              { name: "浙江", value: this.randomData() },
              { name: "江西", value: this.randomData() },
              { name: "湖北", value: this.randomData() },
              { name: "广西", value: this.randomData() },
              { name: "甘肃", value: this.randomData() },
              { name: "山西", value: this.randomData() },
              { name: "内蒙古", value: this.randomData() },
              { name: "陕西", value: this.randomData() },
              { name: "吉林", value: this.randomData() },
              { name: "福建", value: this.randomData() },
              { name: "贵州", value: this.randomData() },
              { name: "广东", value: this.randomData() },
              { name: "青海", value: this.randomData() },
              { name: "西藏", value: this.randomData() },
              { name: "四川", value: this.randomData() },
              { name: "宁夏", value: this.randomData() },
              { name: "海南", value: this.randomData() },
              { name: "台湾", value: this.randomData() },
              { name: "香港", value: this.randomData() },
              { name: "澳门", value: this.randomData() },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>
<style>
</style>